const practitionerPicker = {
  practitionerPickerTitle: "Choose a practitioner to write on behalf of.",
  practitionerPickerSubtitle:
    "To create a new practitioner account in your practice, add them in the <1>Fullscript web application</1>.",
};

export { practitionerPicker };
